function deepClone(value, hashMap = new WeakMap()) { //弱应用下次垃圾回收机制执行时，这块内存会被释放， 解决循环引用情况， 另辟一个存储空间，
    if (value == null || typeof value !== 'object') {
        return value;
    }
    if (value instanceof Date) {
        return new Date(value)
    }
    if (value instanceof RegExp) {
        return new RegExp(value)
    }
    let obj = new value.constructor; //兼容数组和对象
    let v = hashMap.get(value);
    if (v) {
        return v;
    }
    hashMap.set(value, obj)
    for (let key in value) {
        if (value.hasOwnProperty(key)) {
            obj[key] = deepClone(value[key], hashMap)
        }
    }
    return obj
}

/**
 * 通过链接下载文件(视频不能使用，视频使用会变成跳转)
 * @param {String} url 链接
 * @param {String} fileName 文件名
 */
function downloadFileUrl(url, fileName) {
    const elink = document.createElement('a')

    elink.href = url

    elink.setAttribute('download', fileName)

    elink.style.display = 'none'

    document.body.appendChild(elink)

    setTimeout(() => {

        elink.click()

        document.body.removeChild(elink)

    }, 66)
}

// 下载视频函数
async function downloadVideo(url, filename) {
    try {
      const response = await fetch(url);
      console.log('response',response);
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.style.display = 'none'; // 隐藏下载链接
      document.body.appendChild(link); // 将链接添加到DOM中
      link.click(); // 触发点击事件
      document.body.removeChild(link); // 移除链接
      URL.revokeObjectURL(link.href); // 释放对象URL
    } catch (error) {
      console.error('Error downloading video:', error);
    }
}

function getImageDimensions(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
        resolve({ width: img.width, height: img.height });
        };

        img.onerror = () => {
        reject(new Error(`Failed to load image: ${url}`));
        };
    });
}

function unique(arr) {
    let hash = {};
    const newArr = arr.reduce((preVal, curVal) => {
        hash[curVal.id] ? '' : hash[curVal.id] = true && preVal.push(curVal);
        return preVal
    }, [])
    return newArr
}

//函数节流：函数在一段时间内多次触发只会执行第一次，在这段时间结束前，不管触发多少次也不会执行函数。
const throttle2 = (fn, gapTime) => {
    if (gapTime == null || gapTime == undefined) {
      gapTime = 1500
    }
  
    let _lastTime = null
  
    // 返回新的函数
    return function () {
      let _nowTime = + new Date()
      if (_nowTime - _lastTime > gapTime || !_lastTime) {
          fn.apply(this, arguments)   //将this和参数传给原函数
          _lastTime = _nowTime
      }
    }
}

//判断手机号码是否合法的手机号码(true合法，false不合法)
let checkPhone = (mobile) => {
    let regu = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
    let re = new RegExp(regu);
    if (re.test(mobile)) {
        return true; //合法
    }
    return false; //不合法
}

function isWeChatBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /micromessenger/.test(userAgent);
}

export default {
    deepClone,
    downloadFileUrl,
    unique,
    throttle2,
    checkPhone,
    downloadVideo,
    getImageDimensions,
    isWeChatBrowser,
}




// WEBPACK FOOTER //
// ./src/digitalHuman/tool/tools.js